module.exports = __webpack_public_path__ + "img/product_desk_10.7f3e0b85.jpg";